const src = import.meta.ROLLUP_FILE_URL_HAwZnQ40A17rYC3Q$lxt9A;
export default {
  src,
  srcSet: src + " " + 302 + "w",
  width: 302,
  height: 314,
};